import CourtReport from './CourtReport';

export default CourtReport;
